export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14406.cee6ea95.jpg";